import type { RouteLocationNormalized } from 'vue-router'

type RoutePropsFn = (route: RouteLocationNormalized) => unknown

let chatPropsResolver: RoutePropsFn | undefined
let guestViewChatPropsResolver: (() => unknown) | undefined
let prepareToCallPropsResolver: RoutePropsFn | undefined
let alarmItemSettingsPropsResolver: RoutePropsFn | undefined
let callSessionPropsResolver: RoutePropsFn | undefined
let functionalKeysPropsResolver: RoutePropsFn | undefined

export const setChatPropsResolver = (fn: RoutePropsFn) => {
  chatPropsResolver = fn
}

export const setGuestViewChatPropsResolver = (fn: () => unknown) => {
  guestViewChatPropsResolver = fn
}

export const setPrepareToCallPropsResolver = (fn: RoutePropsFn) => {
  prepareToCallPropsResolver = fn
}

export const setAlarmItemSettingsPropsResolver = (fn: RoutePropsFn) => {
  alarmItemSettingsPropsResolver = fn
}

export const setCallSessionPropsResolver = (fn: RoutePropsFn) => {
  callSessionPropsResolver = fn
}

export const setFunctionalKeysPropsResolver = (fn: RoutePropsFn) => {
  functionalKeysPropsResolver = fn
}

/**
 * Vue Router does not re-run beforeEnter on param-only changes, and
 * to.meta mutations from beforeEnter do not persist across navigations.
 * Keep a resolver after the first dynamic import and recompute props each time.
 */
export const viewChatPropsFromMeta = (route: RouteLocationNormalized) => {
  if (chatPropsResolver) {
    return chatPropsResolver(route)
  }
  return route.meta.viewChatProps
}

export const guestViewChatPropsFromMeta = () => {
  if (guestViewChatPropsResolver) {
    return guestViewChatPropsResolver()
  }
  return undefined
}

export const prepareToCallPropsFromMeta = (route: RouteLocationNormalized) => {
  if (prepareToCallPropsResolver) {
    return prepareToCallPropsResolver(route)
  }
  return route.meta.prepareToCallProps
}

export const alarmItemSettingsPropsFromMeta = (route: RouteLocationNormalized) => {
  if (alarmItemSettingsPropsResolver) {
    return alarmItemSettingsPropsResolver(route)
  }
  return route.meta.alarmItemSettingsProps
}

export const callSessionPropsFromMeta = (route: RouteLocationNormalized) => {
  if (callSessionPropsResolver) {
    return callSessionPropsResolver(route)
  }
  return route.meta.callSessionProps
}

export const functionalKeysPropsFromMeta = (route: RouteLocationNormalized) => {
  if (functionalKeysPropsResolver) {
    return functionalKeysPropsResolver(route)
  }
  return route.meta.functionalKeysProps
}
